const ESTADOS_FEMININOS = ['BA', 'PB']

/**
 * Formata os quantitativos de equipes por classificação,
 * separando os tipos de equipe e os componentes.
 *
 * @param {Object|null} item
 * @returns {string}
 */
export function formatarEquipesClassificacao(item) {
  if (!item) return ''

  const equipes = [
    { key: 'esf_cvat', label: 'CVAT eSF' },
    { key: 'eap_cvat', label: 'CVAT eAP' },
    { key: 'esf_qual', label: 'CQ eSF' },
    { key: 'eap_qual', label: 'CQ eAP' },
    { key: 'esb_qual', label: 'CQ eSB' },
    { key: 'emulti_qual', label: 'CQ eMulti' },
    { key: 'esfr_qual', label: 'CQ eSFR' },
    { key: 'eapp_qual', label: 'CQ eAPP' },
    { key: 'ecr_qual', label: 'CQ eCR' },
  ]

  return equipes
    .filter(({ key }) => Number(item[key] || 0) > 0)
    .map(({ key, label }) => `${Number(item[key])} ${label}`)
    .join('\n')
}

/**
 * Ranking na faixa de porte populacional (ex.: "21º no BR 6K").
 * @param {Object} municipio
 * @returns {string}
 */
export function formatarPosicaoFaixaBr(municipio) {
  if (
    !municipio ||
    municipio.posicao_faixa_pop == null ||
    municipio.posicao_faixa_pop === ''
  ) {
    return ''
  }
  const porte = Number(municipio.int_faixa_port_pop || 0)
  if (!porte) return `${municipio.posicao_faixa_pop}º no BR`
  return `${municipio.posicao_faixa_pop}º no BR ${porte}K`
}

/**
 * Ranking geral no Brasil (ex.: "5009º no BR").
 * @param {Object} municipio
 * @returns {string}
 */
export function formatarPosicaoBr(municipio) {
  if (
    !municipio ||
    municipio.posicao_br == null ||
    municipio.posicao_br === ''
  ) {
    return ''
  }
  return `${municipio.posicao_br}º no BR`
}

/**
 * Tema do cartaz a partir da melhor posição.
 * @param {Object} municipio
 * @returns {'ouro'|'prata'|'bronze'|'neutro'}
 */
export function resolverTemaDesempenho(municipio) {
  const regional = Number(municipio?.posicao_regiao_saude || 999)
  const uf = Number(municipio?.posicao_uf || 999)
  const br = Number(municipio?.posicao_br || 999)
  const melhor = Math.min(regional, uf, br)

  if (melhor === 1) return 'ouro'
  if (melhor === 2) return 'prata'
  if (melhor === 3) return 'bronze'
  return 'neutro'
}

/**
 * Monta o objeto de query params para a página do editor.
 * @param {Object} municipio
 * @param {{ page?: string, regiao?: string }} [contexto]
 * @returns {Object}
 */
export function montarQueryCartaz(municipio, contexto = {}) {
  if (!municipio) return {}

  const uf = municipio.uf || ''
  const artigo = ESTADOS_FEMININOS.includes(uf) ? 'na' : 'no'
  const tema = resolverTemaDesempenho(municipio)
  const percentual =
    municipio.desempenho != null && municipio.desempenho !== ''
      ? String(municipio.desempenho).replace('%', '')
      : municipio.notaGeral != null
      ? String(municipio.notaGeral)
      : ''

  const query = {
    ibge: municipio.ibge != null ? String(municipio.ibge) : '',
    municipio: `${municipio.municipio || ''} - ${uf}`.trim(),
    uf,
    quadrimestre: municipio.quadrimestre || '',
    percentual,
    ranking1: `${Number(municipio.posicao_regiao_saude || 0)}º na Regional`,
    ranking2: `${Number(municipio.posicao_uf || 0)}º ${artigo} ${uf}`,
    // Sempre: faixa de porte (Brasil XK) + Brasil geral.
    ranking3: formatarPosicaoFaixaBr(municipio),
    ranking4: formatarPosicaoBr(municipio),
    regular: formatarEquipesClassificacao(municipio.regular),
    suficiente: formatarEquipesClassificacao(municipio.suficiente),
    boa: formatarEquipesClassificacao(municipio.bom),
    otima: formatarEquipesClassificacao(municipio.otimo),
    tema,
    page: contexto.page || '',
  }

  if (contexto.regiao) {
    query.regiao = contexto.regiao
  }

  // Remove vazios para URL mais curta
  Object.keys(query).forEach((key) => {
    if (query[key] === '' || query[key] == null) delete query[key]
  })

  return query
}
